import { Injectable } from '@angular/core';
import {LocalStorageService} from "library";
import {LocalStorageKey, Role, Permission} from "projects/store/src/app/enums";
import {UserData} from "projects/store/src/app/interfaces";

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  userData!: UserData;

  constructor(private localStorageService: LocalStorageService) {
  }

  checkPermission(permission: any) {
    this.userData = this.localStorageService.get(LocalStorageKey.data)
    let permitedRoles: string[] = this.getRoles(permission)

    if(!permitedRoles) {
      console.error("Funcion no identificada", permission);
      return false;
    }else if(permitedRoles.includes(this.userData.user.role.code) && this.checkExtraCondition(permission)) {
      return true;
    }
    return false;
  }

  getRoles(permission: string) {
    let manager = Role.manager;
    let commercialManager = Role.commercial_manager;
    let seller = Role.salesman;
    let sellerCashier = Role.salesman_cashier;
    let cashier = Role.cashier;

    switch (permission) {
      // Ventas
      case Permission["Ventas"]:
      case Permission["Ventas.NuevaSolicitud"]:
      case Permission["Ventas.ContinuarSolicitud"]:
      case Permission["Ventas.VerCatalogo"]:
      case Permission["Ventas.PrecalificacionCredito"]:
        return [seller, sellerCashier, manager];
      //  Recaudos
      case Permission["Recaudos"]:
      case Permission["Recaudos.RecargasCW"]:
      case Permission["Recaudos.LukiCashIn"]:
      case Permission["Recaudos.LukiCashOut"]:
        return [seller, cashier, sellerCashier, manager];
      //  Gestion
      case Permission["Gestion"]:
      case Permission["Gestion.Precios"]:
      case Permission["Gestion.EstadoCuenta"]:
        return [seller, sellerCashier, manager, commercialManager];
      case Permission["Gestion.Comercial"]:
      case Permission["Gestion.Comercial.Dashboard"]:
      case Permission["Gestion.Comercial.Dashboard.TotalVentasTiendas"]:
      case Permission["Gestion.Comercial.ComisionesPorMarca"]:
      case Permission["Gestion.Comercial.Pagos"]:
      case Permission["Gestion.Comercial.Reportes"]:
        return [seller, sellerCashier, manager, commercialManager];
      case Permission["Gestion.Comercial.Reportes.Ventas"]:
        return [seller, sellerCashier, manager];
      case Permission["Gestion.Comercial.Reportes.Ventas.SeleccionGerenteTienda"]:
        return [manager];
      case Permission["Gestion.Comercial.MisTiendas"]:
      case Permission["Gestion.Comercial.Reportes.SeleccionTienda"]:
        return [commercialManager];
      //  Solicitud de pago
      case Permission["SolicitudPago"]:
      case Permission["SolicitudPago.Buscar"]:
      case Permission["SolicitudPago.GenerarPagoTerceros"]:
        return [cashier, sellerCashier, manager];
      //  Consultas
      case Permission["Consultas"]:
      case Permission["Consultas.PinDesbloqueo"]:
        return [seller, cashier, sellerCashier, manager, commercialManager];
      //  Reportes
      case Permission["Reportes"]: return [seller, cashier, sellerCashier, manager, commercialManager];
      case Permission["Reportes.CierreVentas"]: return [seller, sellerCashier, manager];
      case Permission["Reportes.Ventas"]: return [seller, sellerCashier, manager, commercialManager];
      case Permission["Reportes.PagosTienda"]: return [cashier, sellerCashier, manager, commercialManager];
      case Permission["Reportes.Recaudos"]: return [cashier, sellerCashier, manager, commercialManager];
      case Permission["Reportes.VentasProductosAdicionales"]: return [seller, cashier, sellerCashier, manager, commercialManager];
      //  Tienda
      case Permission["Tienda.Configuracion.Geolocalizacion"]: return [manager];

      default: return [];
    }
  }


  checkExtraCondition(permission: string) {
    let data = this.localStorageService.get(LocalStorageKey.data);
    if (data.store !== null) {
      return this.storePermmissions(permission);
    }else if (data.distributor !== null) {
      return this.distributorPermmissions(permission);
    }
  }

  distributorPermmissions(permission: string) {
    let data = this.localStorageService.get(LocalStorageKey.data);
    switch (permission) {
      case Permission["Gestion.Comercial"]:
        return data.distributor.setting.configured_commission;

      default: return true;
    }
  }


  storePermmissions(permission: string) {
    let data = this.localStorageService.get(LocalStorageKey.data);
    switch (permission) {
      // Ventas
      case Permission["Ventas.NuevaSolicitud"]:
        // Ventas > GET /requests/allow-sales OK status: 202
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_sales: boolean }}}
        //  salesAllowed: indica si la tienda puede realizar ventas
        // return true;
        return data.store.setting.enabled_sales;

      case Permission["Ventas.PrecalificacionCredito"]:
        // Ventas > environment > {global: { country: { showPrequalifiedButton: true }}}
        // Tiendas > TBD
        return data.store.setting.enabled_pre_score;

      case Permission["Recaudos"]:
        // Ventas > GET /user-details > localStorage > userData habilita_luki || habilita_cw_recarga
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_luki: boolean, enabled_cw_recharge: boolean }}}
        // return true;
        return data.store.setting.enabled_luki || data.store.setting.enabled_cw_recharge;

      case Permission["Recaudos.RecargasCW"]:
        // Ventas > GET /user-details > localStorage > userData habilita_cw_recarga
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_cw_recharge: boolean }}}
        // return true;
        return data.store.setting.enabled_cw_recharge;

      case Permission["Recaudos.LukiCashIn"]:
        // Ventas > GET /user-details > localStorage > userData habilita_luki
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_luki: boolean }}}
        // return true;
        return data.store.setting.enabled_luki;

      case Permission["Recaudos.LukiCashOut"]:
        // Ventas > GET /user-details > localStorage > userData habilita_luki
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_luki: boolean }}}
        // return true;
        return data.store.setting.enabled_luki;

      case Permission["Consultas"]:
      case Permission["Consultas.PinDesbloqueo"]:
        // Ventas > GET /user-details > localStorage > userData.habilita_pin_desbloqueo
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_unlock_pin: boolean }}}
        // return true;
        return data.store.setting.enabled_unlock_pin;

      case Permission["SolicitudPago"]:
      case Permission["SolicitudPago.Buscar"]:
      case Permission["SolicitudPago.GenerarPagoTerceros"]:
        // Ventas > GET /user-details > localStorage > userData.cobro_cuotas
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_payment_request: boolean }}}
        // return true;
        return data.store.setting.enabled_payment_request;

      case Permission["Reportes.Recaudos"]:
        // Ventas > GET /user-details > localStorage > userData habilita_luki || habilita_cw_recarga
        // Tiendas > GET /merchant/user/${id} > { store: { setting: { enabled_luki: boolean, enabled_cw_recharge: boolean }}}
        // return true;
        return data.store.setting.enabled_luki || data.store.setting.enabled_cw_recharge;

      case Permission["Gestion.Comercial"]:
        return data.store.setting.configured_commission;

      case Permission["Tienda.Configuracion.Geolocalizacion"]:
        return data.store.setting.enabled_active_geolocation;

      default: return true;
    }
  }
}
